import React, { useState } from "react";
import { InboxOutlined } from "@ant-design/icons";
import { message, Upload } from "antd";
import { getDocumentById } from "../Application/DocumentUpload.business";
import { getOffsets } from "../../DashboardOffset/Application/DashboardOffset.business";
import { getAreasByUser } from "../../Areas/Application/Areas.business";
import { getSuppliersByUser } from "../../Suppliers/Application/Suppliers.business";
import { getCategoriesByUser } from "../../Categories/Application/Categories.business";
import { getRepositoryProjectByUser } from "../../RepositoryProjects/Application/RepositoryProjects.business";
import { PostDocumentLogic } from "../Application/DocumentUpload.logic";

const { Dragger } = Upload;

export default function DocumentUpload(props) {
  const [values] = useState({
    ...props,
    name: "file",
  });
  const acceptedFileTypes = [".webp", ".svg", ".pdf", ".xlsx"];
  let id;

  const customRequest = async ({ file, onSuccess, onError }) => {
    try {
      const form = new FormData();
      const description = props.description || "Document uploaded";
      form.append("file", file);
      form.append("id", props.id);
      form.append("type", props.type);
      form.append("description", description);

      const document = await PostDocumentLogic(form);

      onSuccess?.(document, file);
    } catch (error) {
      console.error("Upload failed:", error);
      onError?.(error);
    }
  };

  const onChange = async (info) => {
    const { status, name, response = {} } = info.file;
    const responseId = response?.id;
    if (responseId) id = responseId;
    switch (true) {
      case status === "done":
        console.log(responseId);
        const shouldFetch = responseId && !response?.url;
        const document = shouldFetch ? await getDocumentById(id) : response;
        id = document?.id || id;
        message.success(`${name} ha sido cargado con éxito.`);
        refreshDataAfterFileUpload();
        const imageTypes = [
          "main_image_project",
          "first_image_sensors",
          "second_image_sensors",
          "third_image_sensors",
          "gallery_image",
          "image_project",
        ];

        if (imageTypes.includes(props.type)) {
          if (window.reloadProjectImages) {
            console.log("Recargando imágenes del proyecto...");
            await window.reloadProjectImages();
          }
        }

        props.updateImage?.(document);
        return (
          props.type === "profile_picture" && values.setProfile(document.url)
        );
      case status === "error":
        return message.error(`${name} no ha podido ser cargado.`);
      default:
        break;
    }
  };

  const handleFileUpload = (file) => {
    const fileExtension = file.name
      .substring(file.name.lastIndexOf("."))
      .toLowerCase();

    if (!acceptedFileTypes.includes(fileExtension)) {
      message.error(
        "Tipo de archivo no válido. Solo se permiten archivos con extensión svg y webp."
      );
      return Upload.LIST_IGNORE;
    }

    return true;
  };

  const refreshDataAfterFileUpload = () => {
    getOffsets(id);
    getAreasByUser(id);
    getSuppliersByUser(id);
    getCategoriesByUser(id);
    getRepositoryProjectByUser(id);
  };

  const isAcceptedType = [
    "main_image_project",
    "first_image_sensors",
    "second_image_sensors",
    "third_image_sensors",
    "carbon_management_file",
  ].includes(props.type);

  return (
    <>
      <Dragger
        onChange={onChange}
        name={values.name}
        customRequest={customRequest}
        disabled={props.disabled}
        accept={isAcceptedType ? ".webp,.svg,.pdf,.xlsx" : null}
        beforeUpload={isAcceptedType ? handleFileUpload : null}
        data={{
          ...props,
          description: props.description,
        }}
        style={{ padding: 20 }}
      >
        <p className="ant-upload-drag-icon">
          <InboxOutlined style={{ color: "#1890ff" }} />
        </p>
        <p className="ant-upload-text">Arrastra tu imagen aquí</p>
        <p className="ant-upload-hint">
          O haz clic para seleccionar desde tu dispositivo
        </p>
      </Dragger>
      {/* <div style={{ textAlign: "center", marginTop: 16 }}>
        <Button
        style={props.disabled ? styles.disabled : {}}
        icon={<UploadOutlined />}
      >
         {props.buttonText || "Seleccionar Archivo"}
      </Button>
     </div> */}
    </>
  );
}
